export default {
  'app.pwa.offline': 'Bạn hiện đang offline',
  'app.pwa.serviceworker.updated': 'Có nội dung mới',
  'app.pwa.serviceworker.updated.hint':
    'Vui lòng nhấn nút "Làm mới" để tải lại trang hiện tại',
  'app.pwa.serviceworker.updated.ok': 'Làm mới',
};
